/**
 * Web shim for react-native-reanimated.
 *
 * react-native-reanimated is an OPTIONAL peer of react-native-gesture-handler.
 * The gesture handler wraps its import in a try/catch, so if the module is
 * absent gestures degrade gracefully.  This no-op shim silences the webpack
 * "module not found" warning so build output stays clean.
 */

import { Animated } from 'react-native';

export const Value         = Animated.Value;
export const ValueXY       = Animated.ValueXY;
export const Clock         = class Clock {};
export const Node          = class Node {};
export const Extrapolate   = { CLAMP: 'clamp', EXTEND: 'extend', IDENTITY: 'identity' };

export const useSharedValue              = (v)    => ({ value: v });
export const useAnimatedStyle            = (fn)   => fn();
export const useAnimatedGestureHandler   = ()     => ({});
export const useDerivedValue             = (fn)   => ({ value: fn() });
export const useAnimatedRef              = ()     => ({ current: null });
export const useAnimatedScrollHandler    = ()     => ({});
export const withTiming                  = (v)    => v;
export const withSpring                  = (v)    => v;
export const withDecay                   = ()     => 0;
export const withRepeat                  = (v)    => v;
export const withSequence                = ()     => 0;
export const runOnJS                     = (fn)   => fn;
export const runOnUI                     = (fn)   => fn;
export const interpolate                 = (v)    => v;
export const interpolateColor            = (v)    => v;
export const cancelAnimation             = ()     => {};

export { Animated };

export default {
  Value, ValueXY, Clock, Node, Extrapolate,
  useSharedValue, useAnimatedStyle, useAnimatedGestureHandler,
  useDerivedValue, useAnimatedRef, useAnimatedScrollHandler,
  withTiming, withSpring, withDecay, withRepeat, withSequence,
  runOnJS, runOnUI, interpolate, interpolateColor, cancelAnimation,
  Animated,
};
